import React, { useCallback } from "react"
import { Downgraded, useHookstate, type State } from "@hookstate/core";
import { useLang } from "~/hooks/useLang";
import { FormControl, Grid, TextField } from "@mui/material";
import Buttons from "../../../DispatchRegistrationTab/components/Buttons";
import useDispatchRegistrationOthersState from "~/features/Dispatch/stores/DispatchRegistrationOthersState";
import notify from "~/utils/notify";
import useDispatchRegistrationState from "~/features/Dispatch/stores/DispatchRegistrationState";
import dispatch from "~/components/IconsSvg/dispatch";
import useDispatchState from "~/features/Dispatch/stores/DispatchState";

interface FormOthers {
  readonly loading: State<boolean>
  readonly handleEdit: () => void;
  readonly handleClickOpenConfirmAction: (action: string) => void
}

export default function FormOthers({ handleEdit, loading, handleClickOpenConfirmAction }: FormOthers) {
  const { translate } = useLang();
  const { registrationOtherDispatch, sendOtherRecord } = useDispatchRegistrationOthersState()
  const { other } = registrationOtherDispatch()
  const { registrationDispatch } = useDispatchRegistrationState();
  const { inputErrors, addRegistration } = registrationDispatch();
  const { dispatch } = useDispatchState();
  const { status } = dispatch();
  const disableFields = status.value.id === 8

  const someInvalidInput = () => {
    if (!other.get().item) {
      inputErrors.item.set(true)
    }

    return Object.values(inputErrors.attach(Downgraded).get()).some(value => !!value)
  }

  const handleSend = useCallback(async () => {
    loading.set(true)
    await sendOtherRecord(other.get()).finally(() => {
        loading.set(false)
      })
    notify({ message: translate('Successfully created'), type: 'success' })
    addRegistration.set(false)
  }, [addRegistration, sendOtherRecord, translate, other])

  return (
    <FormControl fullWidth size='small'>
      <Grid container direction={'row'}>
        <Grid item xs={6} sx={{ padding: 1, marginBottom: 1 }}>
          <TextField
            // disabled={disableFields}
            id="outlined-multiline-static"
            label={translate('Item')}
            fullWidth
            size='small'
            rows={2}
            value={other.get().item}
            InputProps={{
              onChange: (event) => {
                const item = event.target.value
                other.merge({
                  item,
                })
              }
            }}
            // sx={{ height: 50 }}
          />
        </Grid>
        <Grid item xs={12} sx={{ padding: 1, marginBottom: 1 }}>
          <TextField
            // disabled={disableFields}
            id="outlined-multiline-static"
            label={translate('Note')}
            multiline
            fullWidth
            size='small'
            rows={2}
            value={other.get().notes}
            InputProps={{
              onChange: (event) => {
                const notes = event.target.value
                other.merge({
                  notes,
                })
              }
            }}
            sx={{ height: 50 }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Buttons
          loading={loading}
          isUpdate={!!other.id.get()}
          handleClickOpenConfirmAction={handleClickOpenConfirmAction}
          handleEdit={handleEdit}
          handleSend={handleSend}
          someInvalidInput={someInvalidInput}
          disableFields={disableFields}
        />
      </Grid>
    </FormControl>
  )
}